// extracted by css-extract-rspack-plugin
module.exports =  {"root":"IconVisual__root___BpMZX","muted":"IconVisual__muted___m7zRR","tight":"IconVisual__tight___JO_PK"};